import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/custom-portal-view/components/PortalViewInteractive.tsx");
